import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ApplicationStatusEnum } from '@tran-monorepo/interfaces/applications';

@Component({
    selector: 'tran-application-status-badge',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './application-status-badge.component.html'
})
export class ApplicationStatusBadgeComponent {
    public readonly status = input.required<ApplicationStatusEnum>();

    protected readonly ApplicationStatus = ApplicationStatusEnum;
}
